export const EngagementDetails = {};

export const severitymessage = {
  success: 'success',
  error: 'error',
  info: 'info',
  exist: 'exist',
  summary: 'Project',
  warn: 'warn',
  somethingwrong: 'Something went wrong',
  key: 'myKey1',
  key2: 'myKey2',
  notification: 'Notification',
  FileUpload: 'File uploaded successfully',
  NoChange: 'No Modification Made',
  SaveStd: 'Failed to save Project',
  FormateError: 'Invalid file format.',
  Error: 'Failed',
  DownloadError: 'Failed to download the databook',
  UpdatedAdjustment: 'Adjustment updated successfully',
  ExportExcel: 'Data tab updated successfully<br/>Do you want to export to Excel?',
  UploadError: 'Upload error',
  MaxsizeError: 'Cannot upload',
  NetworkError: 'Network Connection',
  InvalidData: 'Invalid data',
  MappingDataError: 'Invalid mapping data.',
  UploadDatabook: 'Working version of your databook is uploaded successfully.',
  DatabookFileFormatError: 'Please upload working version of macros enabled databook',
  AssessmentCancelRequested: 'Assessment cancellation requested.',
  AnalyticsReportDownloaded: 'Analytics report downloaded successfully',
  UsersAnalyticsReportDownloaded: 'Analytics report downloaded successfully',
  MutiFileUploadError: 'Please upload single at a time.',
  AuditLogReportDownloaded: 'Audit log downloaded successfully',
  DuplicateAddAdjustmentnames: 'Adjustment Name already exist'
};

export const EngagementDetailMessage = {
  SuccessMessage: {
    Created: 'Project added successfully',
    Updated: 'Project updated successfully',
    Reactivated: 'Project re-activated sucessfully'
  },
  summary: {
    enagagement: 'Engagement',
  },
  ErrorMessage: {
    Updated: 'Failed to update Project',
  }
};

export const UploadSourcefilemessage = {
  SuccessMessage: {
    Created: 'SourceFile created successfully',
    Delete: 'Source file deleted successfully',
  },
  summary: {
    sourcefile: 'SourceFile',
  },
  Info: {
    EmptyUploadedData: 'Could not found any uploaded files'
  },
  confirmMessage: {
    Confirm: 'This file is in use.<br/>Do you really want to delete it?',
    confirmDelete: 'Are you sure want to delete this file?',
  },
  ErrorMessage: {
    NetworkError: 'Network issue while uploading the file.',
    FormateError: 'File format is not supported, Please upload databook in xlsx / xlsm format.',
    DeleteError: 'Unable to delete the file!',
    DownloadError: 'Unable to download the file!',
    AddError: 'Cannot add',
    Delete: 'Delete error',
    Upload: 'Upload error',
    DownloadHeader: 'Upload error',
    Uploaderror: 'Due to technical issue file could not uploaded successfully.Please delete the file and try again.'
  }
};

export const PreviewSourcefileComponentmessage = {
  ErrorMessage: {
    EmptyBoxError: 'Please verify highlighted boxes',
    MultipleFileError: 'Cannot use multiple files',
    InvalidInputs: 'Invalid inputs',
    EmptyCheckBoxError: 'Please select the sheet for processing',
    PeriodCheckError: 'Please select period month',
    PeriodYearCheckError: 'Please select period year',
    EndDateCheckError: 'Please select end date',
    PeriodHashError: 'Please select period#',
    InvalidMonthError: 'Please enter the month in mmm / full month text format.',
    InvalidPeriodNumberError: 'Please ensure that period(s) across all tabs is between 1 - 13',
    InvalidYearError: 'Please enter the year in YYYY or YY format.',
    InvalidFiscalYearError: 'Please ensure that year is same or greater than start date of first fiscal year.',
    InvalidFiscalYearErrorForNonDec: 'Please ensure that year is greater than start date of first fiscal year.',
    InvalidYearType: 'Please specify whether the provided year is fiscal / calendar year.',
    MonthValidCheckError: 'Please provide correct month for processing',
    EndDateTabMissedError: 'Please provide end date for highlighted tabs',
    EndDateValidationUSTemplateFormatError: 'Please provide end date in mm-dd-yyyy or mm/dd/yyyy format.',
    EndDateValidationOtherTemplateFormatError: 'Please provide end date in dd-mm-yyyy or dd/mm/yyyy format.',
    GroupEndDateValidCheckError: 'Please set a different group for unique combination of end date and business segment(s) inputs.',
    GroupValidCheckError: 'Please set a different group for unique combination of month, year and business segment(s) inputs.',
    invalidTab: 'Application can process maximum of 36 tabs, please merge data across sheets or tabs.',
    PreviewSheetRowExceedCountMessage: 'Preview unavailable due to large number of records. Please refer to source file[s] ' +
      'for population of user inputs.',
    PreviewSheetSizeExceedMessage: 'Preview unavailable due to large file size. Please refer to source file[s] for population' +
      ' of user inputs.',
    BSegmentInTheSheetMessage: 'Business segment 2 has to be “In sheet”, if business segment 1 is “In sheet”',
    BSegmentNoneMessage: 'Business segment 2 has to be blank, if business segment 1 is “None”'
  }
};

export const InputCaptureComponentmessage = {
  ConfirmMessage: {
    ConfirmResetProcessing: 'Are you sure you want to reset processing?',
    ConfirmPreviewProcessing: 'Please check the inputs on preview and attribute screen before processing ahead.'
  },
  SuccessMessage: {
    AddDataMsg: 'User Inputs Saved Successfully',
    UserInput: 'User Inputs',
    ResetProcessing: 'Processing reset successfully'
  },
  ErrorMessage: {
    Blank: 'Tab should not be blank.',
    Mandatory: 'Please enter details in mandatory fields',
    ErrorResetProcessing: 'Failed to reset processing',
    SelectedField: 'Please enter the Account descriptions as single cell reference (A5) or multi cellreference (A5:E5)',
    AccountIdField: 'Please enter Account Id as single cell reference',
    SubTotal: 'Please select one of the sub-total identifiers',
    BusinessSegment: 'Please provide single cell reference. For multiple entities, provide the range of columns in a single row ' +
      '(e.g. C5:H5)',
    PeriodM: 'Please provide single cell reference. For multiple entities, provide the range of columns in a single row (e.g. D4:AB4)',
    statementAmount: 'Please provide single cell reference or formula depending on debit & creditcolumn (e.g. C4-D4 / C4+D4)',
    LastCellAccountDescription: 'Please enter the last cell of Account descriptions as single cell reference (A5) or multi cellreference' +
      ' (A5:E5)',
    validatePeriodMonthYearDescription: 'Please provide single cell reference. For multiple entities, provide the range of columns in a' +
      ' single row(e.g. D4:AB4)',
    specialCharacterValidationText: 'Please provide special character for separator',
    PreviewSheetRowExceedCountMessage: 'Preview unavailable due to large number of records. Please refer to source file[s] for population' +
      ' of user inputs at left.',
    PreviewSheetSizeExceedMessage: 'Preview unavailable due to large file size. Please refer to source file[s] for population of user' +
      ' inputs at left.'
  },
  Summary: {
    Processing: 'Reset Processing',
  }
};

export const MappingselectionComponentmessage = {
  ConfirmMessage: {
    ConfirmResetProcessing: 'Are you sure you want to reset mapping?'
  },
  SuccessMessage: {
    AddFile: 'Mapping uploaded successfully.',
    ResetMapping: 'Mapping reset successfully',
    SaveHierarchy: 'Mapping By Hierarchy saved successfully',
    UpdateStdMappings: 'Standardized mapping updated successfully'
  },
  Summary: {
    SaveMapping: 'Save Mapping By Accounts',
    UpdateMapping: 'Update Mapping Source',
    SaveHierarchy: 'Save Mapping By Hierarchy',
    Suggestion: 'Mapping Suggestion',
    EngDetails: 'Engagement Details',
    resetMapping: 'Reset mapping',
    UploadManualMapping: 'Upload Manual Mapping',
    NoBlankRange: 'Please add range for current row and then click on \'+\' icon',
    StartOrEndRangeMissingValidation: 'Please provide start/end range for highlighted mappings.',
    rangevalidation: 'End range should be greater than start range for highlighted mapping.',
    negativeValidation: 'Range should be non-negative numeric.'
  },
  ErrorMessage: {
    UploadSummary: 'Failed to upload mapping file',
    cannot: 'Cannot add ',
    DeleteError: 'Failed to load enagagement details',
    required: 'StandardizedMapping is mandatory.',
    ErrorResetMapping: 'Failed to reset mapping',
    NoBlankRange: 'Cannot Add Blank',
    rangevalidation: 'Invalid Range',
    QueueInProgress: 'Manual Mapping upload is already in progress.'

  },
  DetailMessage: {
    noData: 'No data in Mapping by account ID',
    anyOneData: 'Data is missing',
    overlappingRange: 'Account ID range is overlapped for highlighted mappings. Please provide non-overlapping ranges for each mapping.',
  }
};

export const MappingHierarchyUpdateComponentmessage = {
  ConfirmMessage: {
    ConfirmResetProcessing: 'Setting the Mapping at Parent level will overwrite Child Mappings - Do you want to overwrite?'
  },
  SuccessMessage: {
    AddFile: 'Mapping uploaded successfully.',
    ResetMapping: 'Mapping reset successfully',
    SaveHierarchy: 'Mapping By Hierarchy saved successfully',
  },
  Summary: {
    SaveMapping: 'Save Mapping By Accounts',
    UpdateMapping: 'Update Mapping Source',
    SaveHierarchy: 'Save Mapping By Hierarchy',
    Suggestion: 'Mapping Suggestion',
    EngDetails: 'Engagement Details',
    resetMapping: 'Reset mapping',
    UploadManualMapping: 'Upload Manual Mapping',
    NoBlankRange: 'Please add range for current row and then click on \'+\'',

  },
  ErrorMessage: {
    UploadSummary: 'Failed to upload mapping file',
    cannot: 'Cannot add',
    DeleteError: 'Failed to load enagagement details',
    required: 'StandardizedMapping is mandatory.',
    ErrorResetMapping: 'Failed to reset mapping',
    NoBlankRange: 'Cannot Add Blank',

  }
};

export const RemediationComponentmessage = {
  SuccessMessage: {
    SourceFileDelete: 'SourceFile Deleted successfully',
    MappingDelete: 'Record deleted successfully'
  },
  Summary: {
    Verification: 'Mapping',
  },
  confirmMessage: {
    confirmDelete: 'Do you really want to delete this record? If yes, this record will be permanently removed from the data and will not' +
      ' be used in the generation of the databook.',
    PushLibrary: 'Would you like to submit standardized account mappings to make Databook Automation smarter?',
    PushLibraryLongMsg: 'Please ensure that all account mappings to the standardized mappings are correct. If you proceed, these' +
      ' standardized mapping suggestions will be saved in the database and recommended through the "Automated mapping" selection for' +
      ' other users who come across the same account.',
    DeleteSuggestion: `Would you like to report this suggesstion as inaccurate?<br/>
                       Selecting yes will remove this standardized mapping suggestion from the account<br/>
                       mapping database and it will no longer be suggested for this exact account description.`,
    MappingConflict: `Account(s) with blank mapping could be due to conflicting mapping 1 selection (PL/BS) on user input and
                      exact match found in mapping library. Please update selection on user input or through verification
                      screen itself.`
  },
  ErrorMessage: {
    MappingError: 'Standardized mappings are mandatory.',
    MappingDeleteError: 'Unable to delete record!',
    Delete: 'Delete error',
    Failure: 'Unable to save record!',
    UploadSummary: 'Failed to upload flat file',
    FailedToUploadMappingSummary: 'Invalid data in mapping!',
    DownloadSummary: 'Failed to download flat file',
    QueueInProgress: 'Mapping file upload is already in progress.'
  }
};

export const PerformdatacheckComponentmessage = {
  SuccessMessage: {
    MappingUpdation: 'Mapping updated successfully',
  },
  ErrorMessage: {
    UpdatingError: 'Failed to update Mapping',
    QueueInProgress: 'Flat file upload is already in progress.'
  },
  RetainedEarnings: {
    Success: {
      plugMessage: 'Retained earnings are plugged successfully.',
      unplugMessage: 'Plugged retained earnings are unplugged successfully.'
    },
    Failure: 'Error occured in updating retained earnings'
  }
};

export const SignflipSuccessMessage = {
  SuccessMessage: {
    SignflipUpdation: 'Sign flip successful for selected account(s)',
  },
  ErrorMessage: {
    UpdatingError: 'Failed to update Sign flip',
  },
  RetainedEarnings: {
    Success: 'Sign flip updated successfully',
    Failure: 'Error occured in updating Sign flip'
  }
};

export const SchedulesComponentmessage = {
  ConfirmMessage: {
    ConfirmDatabook: 'Are you sure you want to overwrite databook, clicking on Yes will update entire databook?',
  },
  UploadWarning: {
    message: 'Uploading the databook would set the parameters and restrict the selection for future downloads'
  },
  Summary: {
    Schedule: 'Schedule',
  },
  ErrorMessage: {
    ScheduleError: 'Please select atleast One Schedule',

    databook: 'Error while generating databook.',
    SaveSchedule: 'Failed to save SubSchedules',
    Mandatory: 'Please Select Mandatory Fields',
    YearFormat: 'Year should be in YYYY format',
    YearError: 'To Year should be greater than From Year',
    MonthError: 'To Month should be greater than From Month',
    LessThan13MonthError: 'If you would like to generate databook, ensure the period range is at least 13 periods. If your data is less than 13 periods, you can set the range to be 13 periods or greater and periods without data will be displayed as zero values.',
    LessThan12MonthError: 'If you would like to generate databook, ensure the period range is at least 12 months.' +
      ' If your data is less than 12 months, you can set the range to be 12 months or greater and months without data' +
      ' will be displayed as zero values.',
    QueueInProgress: 'Databook generation is already in progress.',
    MissingPeriodsP445: 'Databook cannot be generated for selected period as intermediate periods are missing. To generate databook, please select end date(s) based on project inputs.'
  }
};

export const HomeComponentMessage = {
  Greetings: {
    WelcomeMessage: 'Welcome to databook application. Please create your first project to process the data and generate a Databook.'
  }
};

export const AddEditadjustmentComponentmessage = {
  SuccessMessage: {
    AddAdjustment: 'Adjustment added successfully',
  },
  summary: {
    adjustment: 'Adjustment',
  },
  ErrorMessage: {
    Updated: 'Failed to update Adjustment',
    FailedAdjustment: 'Failed to save Adjustment',
  }
};

export const DatabookComponentmessage = {
  SuccessMessage: {
    DatabookExport: 'Databook generated successfully<br/>Do you want to export to Excel?',
  },

};

export const DownloadUploadFlatfileComponentmessage = {
  Summary: {
    UploadFlatFile: 'Upload Flat File',
    DownloadFlatFile: 'Download Flat File'
  },
  ErrorMessage: {
    UploadSummary: 'Failed to upload flat file',
    DownloadSummary: 'Failed to download flat file',
    DownloadFlatFileTemplateSummary: 'Failed to download flat file',
    DownloadFlatFileInfo: 'Downloading Flat file template',
    QueueInProgress: 'Flat file upload is already in progress.'
  },
  SuccessMessage: {
    RowsUploaded: ' rows uploaded successfully'
  }
};

export const DownloadUploadAdjustmentComponentmessage = {
  Summary: {
    UploadFlatFile: 'Upload Adjustment File',
    DownloadFlatFile: 'Download Adjustment File'
  },
  ErrorMessage: {
    UploadSummary: 'Failed to upload Adjustment file',
    DownloadSummary: 'Failed to download Adjustment file',
    DownloadFlatFileTemplateSummary: 'Failed to download Adjustment file',
    DownloadFlatFileInfo: 'Downloading Adjustment file template'
  },
  SuccessMessage: {
    RowsUploaded: 'Adjustment Data uploaded successfully'
  }
};

export const ValidationsComponentmessage = {
  SuccessMessage: {
    SaveValidation: 'Formula Validation features are saved successfully.',
    FormulaValidation: 'Formula Validation done successfully.',
    UnbrandingSave: 'Unbranding features are saved successfully.',
    summary: 'Formula Validation',
  },
  ErrorMessage: {
    FormulaSelectionError: 'Please select at least one Formula Validation Feature.',
    BrandingError: 'Please select at least one Unbranding Feature.',
    DownloadSummary: 'Failed to download formula validation log file'
  }
};

export const DeleteEngagementComponentmessage = {
  SuccessMessage: {
    ProjectClose: 'Project Deleted successfully',
  },
  ErrorMessage: {
    CloseProject: 'Failed to delete Project',
    ReversedError: 'Do you wish to delete this project? <br/> Deleting a Project makes all' +
      ' features of this project inaccessible and cannot be reversed.'
  }
};

export const SelectadjustmentComponentmessage = {
  SuccessMessage: {
    AdjustmentSelection: 'Adjustment selection saved successfully',
    Summary: 'Adjustment',
  },
  deleteSuccessMessage: {
    AdjustmentSelection: 'Adjustment selection deleted successfully',
    Summary: 'Adjustment',
  },
  ErrorMessage: {
    AdjustmentSelectionError: 'Please select an adjustment',
  }

};

export const UploadDatabookComponentmessage = {
  ErrorMessage: {
    FileFormate: 'Incorrect File Format!',
    Upload: 'Failed to upload DataBook file',
    UploadLog: 'There are some errors in uploaded file.<br/>Please download log file for more details.',
    DataError: 'Data Check Error',

  }
};

export const ScenarioResultComponentmessage = {
  ScenarioWarningPopup: {
    content: `We're sorry but we were unable to automatically process all your data at this time.<br/>
              While we have considered many different formats, your file format may not be currently supported in this version of the tool.
              Please proceed with databook generation by downloading the flat file template and populating the required fields and
               uploading the completed template.<br/>
              If user inputs are modified, please proceed with Process assessment button.`,
    acceptBtn: 'Download Flat File Template',
    cancelBtn: 'Ignore errors'
  },
  ScenarioConfirmationPopup: {
    content: `Sheets that were not able to pass assessment will be omitted from databook generation`,
    acceptBtn: 'Continue',
    cancelBtn: 'Go back to user inputs'
  },
  confirmMessage: {
    Confirm: 'You would like to try again?',
    ConfirmResetProcessing: 'Are you sure you want to reset processing?'
  },
  ErrorMessage: {
    Error: 'Scenario execution not started due to technical issues.',
    ErrorResetProcessing: 'Failed to reset processing',
  },
  Summary: {
    Processing: 'Reset Processing',
  },
  SuccessMessage: {
    ResetProcessing: 'Processing reset successfully'
  }
};

export const FunctionalityNames = {
  EngagementCreation: 'Engagement Creation',
  TrainingWorkspaceCreated: 'PBI workspace created',
  UploadSourceFileGenerateAssisted: 'Uploaded source file (Assisted workflow)',
  UploadFlatFile: 'Uploaded flat file (Template workflow)',
  AssessmentSuccess: 'Assessment Success',
  AssessmentFailure: 'Assessment Failure',
  FlatFileDownload: 'Downloaded flat file',
  OnlineDatabookGeneration: 'Generate online databook',
  OfflineDatabookGeneration: 'Generate offline databook',
  PowerPivotDatabookGeneration: 'Generate powerpivot databook',
  AutomatedMapping: 'Automated Mapping',
  DragAndDrop: 'Drag-n-Drop',
  MappingByAccountId: 'Mapping by account id',
  ManualMapping: 'Manual Mapping',
  ResetMapping: 'Reset Mapping',
  ResetDatabook: 'Reset Databook',
  SignFlip: 'Sign flip',
  PLugUnplug: 'Plug/unplug net income to retained earnings',
  OtherIncomeAddedToEBITDA: 'Other income added to EBITDA',
  ModifyUserInput: 'Modify user inputs',
  PowerBIFlatFile: 'Power BI report',
  UploadDatabook: 'Upload databook',
  EndDateBasedOnProjectInput: 'End date based on project input (4/4/5)',
  EndDateBasedOnSourceFile: 'End date based on source files (4/4/5)',
};

export const UnAuthorizedMessage = {
  Engagement: 'You are not authorized to access this project, kindly contact databook administration',
  AnalyticsReport: 'You are not authorized to access this report, kindly contact databook administration',
  ClosedProject: 'The project details cannot be viewed as the engagement has been closed / inactivated.',
  Common: 'You are not authorized to access this page, kindly contact databook administration'
};

export const DeleteAdjustmentmessage = {
  SuccessMessage: {
    RemoveAdjustment: 'Project deleted successfully',
  },
  ErrorMessage: {
    RemoveAdjustment: 'Would you like to delete the selected adjustments?',
    ReversedError: 'Failed to delete Adjustment'
  }
};

export const LanguageConstants = {
  LANG_CODE: 'lang_code',
  DB_LANG_CODE: 'db_lang_code',
  US_ENG_LOCALE: 'en-US',
  SPANISH_LOCALE: 'es-ES',
  GERMAN_LOCALE: 'de-DE',
  UK_ENG_LOCALE: 'en-GB',
  FRENCH_LOCALE: 'fr-FR',
  ITALIAN_LOCALE: 'it-IT',
  JAPANESE_LOCALE: 'ja-JP',
  CHINESE_LOCALE: 'zh-TW',
  PORTUGAL_LOCALE: 'pt-BR'
};

export const DateFormatConstants = {
  DEFAULT_FORMAT: 'dd-MMM-yyyy',
  DEFAULT_FORMAT2: 'dd MMM yyyy',
  MONTHYEAR: 'MMMM yyyy',
  US_FORMAT: 'MMM/dd/yyyy',
  SPANISH_FORMAT: 'dd/MMM/yyyy'
}

export const AdjustmentMessageConstants = {
  adjustmentError1: 'ADJERR1',
  adjustmentError2: 'ADJERR2',
  adjustmentError3: 'ADJERR3',
  adjustmentError4: 'ADJERR4',
  adjustmentError5: 'ADJERR5',
  adjustmentError6: 'ADJERR6',
  adjustmentError7: 'ADJERR7'
};

export const FlatFileValidationConstants = {
  flatFileMessage1: 'flatFileMessage1',
  flatFileMessage2: 'flatFileMessage2',
  flatFileMessage3: 'flatFileMessage3',
  flatFileMessage4: 'flatFileMessage4',
  flatFileMessage5: 'flatFileMessage5',
  flatFileMessage6: 'flatFileMessage6',
  flatFileMessage7: 'flatFileMessage7',
  flatFileMessage8: 'flatFileMessage8',
  flatFileMessage9: 'flatFileMessage9',
  flatFileMessage10: 'flatFileMessage10',
  flatFileMessage11: 'flatFileMessage11',
  flatFileMessage12: 'flatFileMessage12',
  flatFileMessage13: 'flatFileMessage13',
  flatFileMessage14: 'flatFileMessage14',
  flatFileMessage15: 'flatFileMessage15',
  flatFileMessage16: 'flatFileMessage16',
  flatFileMessage17: 'flatFileMessage17',
  flatFileMessage18: 'flatFileMessage18',
  flatFileMessage19: 'flatFileMessage19',
  flatFileMessage20: 'flatFileMessage20',
  flatFileMessage21: 'flatFileMessage21',
  flatFileMessage22: 'flatFileMessage22',
  flatFileMessage23: 'flatFileMessage23',
  flatFileMessage24: 'flatFileMessage24',
  flatFileMessage25: 'flatFileMessage25',
  flatFileMessage26: 'flatFileMessage26',
  flatFileMessage27: 'flatFileMessage27'
};
